export enum RadioButtonType {
    underline = 'underline',
    none = 'none',
}

export enum RadioTransformType {
    button = 'button',
    radio = 'radio',
}

export interface RadioProps {
    id: string
    text: string
    value: string
    onClick: (value: string, group?: string) => void
    checked?: boolean
    buttonType?: RadioButtonType
    transformType?: RadioTransformType
}
